// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
} */
/* :root {
  --black: #000;
  --white: #f5f5f5;
}

body{
  background: var(--background-color);
  color: var(--text-color);
}

body.light{
  --background-color: var(--white);
  --text-color:var(--black);
}
body.dark{
  --background-color: var(--black);
  --text-color:var(--white);
} */

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.cookie-banner {
  position: fixed;
  bottom: 10px;
  left: 10%;
  right: 10%;
  width: 80%;
  color: #babfc7;
  padding: 5px 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #050420;
  border-radius: 5px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  font-family: 'SFUIDisplayRegular';
}

.cookie-banner p {
  margin-bottom: 0px;
  font-family: 'SFUIDisplayRegular';
  font-size: 13px;
}

.close {
  height: 30px;
  width: 130px;
  font-size: 11px;
  background-color: #32c167;
  border: none;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
}

.react-confirm-alert-overlay {
  background-color: #0e1726ba !important;
}

.react-confirm-alert-body > h1 {
  color: #0e1726e0 !important;
  font-family: 'SFUIDisplay-Medium' !important;
  text-align: center !important;
  font-size: 24px !important;
}

.react-confirm-alert-body {
  background: #fff !important;
  color: #0e1726e0 !important;
  font-family: 'SFUIDisplayRegular' !important;
  text-align: center !important;
  font-size: 14px !important;
  font-weight: bold;
}

.react-confirm-alert-button-group {
  justify-content: center !important;
}
.react-confirm-alert-button-group > button {
  background: #39979d !important;
  color: #fff !important;
  font-family: 'SFUIDisplay-Medium' !important;
}

.react-date-picker__wrapper {
  border: none !important;
}

/*Ag grid Table*/

.ag-theme-alpine .ag-root-wrapper {
  border: none !important;
  background: transparent !important;
  text-overflow: initial !important;
}

.ag-theme-alpine .ag-header {
  border-bottom: none !important;
  margin-bottom: 5px;
  border-radius: 10px !important;
  min-height: 45px !important;
  border: none !important;
  text-overflow: ellipsis !important;
  background: none !important;
}

.ag-header-cell-text {
  text-overflow: ellipsis !important;
}

/* .ag-header-cell-label{
  text-overflow: initial !important;
  overflow: initial !important;
}

.ag-cell-value{
  text-overflow: initial !important;
  overflow: initial !important;
} */

/* @media only screen and (max-width: 400px) {
  .ag-theme-alpine .ag-header-cell{
    width: 91px !important;
  }
} */

/* .ag-root.ag-layout-normal{
  overflow: scroll;
} */

/*Ag grid Pagination*/

.ag-theme-alpine .ag-paging-panel {
  border-top: none !important;
  color: #60677e !important;
  font-size: 12px !important;
  font-family: 'SFUIDisplayRegular' !important;
}
.ag-theme-alpine .ag-icon {
  color: #60677e !important;
}

.ag-theme-alpine .ag-paging-panel > * {
  margin: 0px -2px !important;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  display: flex !important;
  align-items: center;
  text-align: left;
  justify-content: flex-start;
  overflow: hidden;
}

.ag-theme-alpine .ag-ltr .ag-cell .ag-cell-wrapper,
.ag-theme-alpine .ag-ltr .ag-cell .ag-cell-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
  flex: 1 1;
  justify-content: flex-start;
}



/*date range*/

.rdrCalendarWrapper {
  position: absolute;
  z-index: 1;
  box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;
}

.rdrStartEdge,
.rdrInRange,
.rdrEndEdge {
  color: #39979d !important;
}

.rdrDateDisplayItemActive {
  border-color: #39979d !important;
}

.react-date-picker__inputGroup__input,
.react-date-picker__inputGroup__divider {
  color: #60677e !important;
}

.react-date-picker__button svg {
  stroke: #60677e;
}

.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  border: none !important;
  border-color: none !important;
  outline: none !important;
}

/* .ag-theme-alpine .ag-row-selected{
  background: initial !important;
} */

/* .ag-theme-alpine .ag-row-hover{
  background: #fff !important;
} */

.ag-center-cols-viewport {
  height: calc(100% + 12px) !important;
}

.css-qc6sy-singleValue {
  color: #60677e !important;
}

.popup-arrow {
  display: none !important;
}

input[type='checkbox' i] {
  accent-color: #39979d !important;
  vertical-align: middle;
}

input:focus {
  outline: none !important;
}

div[aria-expanded^='false'] .arrowdown {
  display: initial !important;
}

div[aria-expanded^='false'] .arrowup {
  display: none !important;
}

div[aria-expanded^='true'] .arrowup {
  display: initial !important;
}

div[aria-expanded^='true'] .arrowdown {
  display: none !important;
}

/* hide edge default eye icon */
input::-ms-reveal,
input::-ms-clear {
  display: none !important;
}
.nav-item svg {
  color: #747474;
}
.nav-item span {
  color: #747474;
}
.DashMenu_menulinklightSelected__-6pNS a svg {
  color: #020202 !important;
}
/* .list-unstyled .collapsed svg {
  color: #747474 !important;
}
.list-unstyled .collapsed span {
  color: #747474 !important;
}
.list-unstyled .btn-toggle a svg {
  color: #020202;
}
.nav-item .list-unstyled .btn-toggle span {
  color: #020202;
}
.nav-item .DashMenu_menulinklightSelected__-6pNS span {
  color: #020202 !important;
} */

.has-active-sub-links {
  color: #020202 !important;
}
.has-active-sub-links span {
  color: #020202 !important;
}
.has-active-sub-links svg {
  color: #020202 !important;
}

.delete {
  background-color: rgb(214, 33, 33) !important;
}
.btn-toggle-nav li a {
  column-gap: 0px !important;
  padding: 0px 10px 0px 0px !important;
}
@media only screen and (max-width: 580px) {
  body .buttons_resp {
    display: block !important;
  }
  .buttons_resp button {
    display: inline-block;
    margin-right: 10px;
  }
}

/* giving custom cursor pointer to ag grid rows */
.ag-grid-custom-cp .ag-row {
  cursor: pointer !important;
}

.ag-header-cell {
  cursor: default !important;
}

.ag-header-cell-label {
  cursor: pointer !important;
  justify-content: flex-start;
  overflow: hidden;
}

.ag-header-cell-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}



.ag-row-selected {
  background-color: white !important;
}

body .exp_card {
  max-width: 600px;
  text-align: center;
  margin: auto;
  border: solid 1px #e8e8e8;
  border-radius: 10px;
}
.exp_card h1 {
  color: #041c3a;
  font-weight: 700;
  font-size: 38px;
}
.exp_card a {
  -webkit-text-decoration: auto;
          text-decoration: auto;
  color: #ffffff;
  font-size: 18px;
  background: #39979d;
  padding: 7px 14px;
  border-radius: 5px;
  display: inline-block;
}
.exp_card a:hover {
  color: #ffffff;
  background: #114144;
}

.ql-editor {
  min-height: 250px !important;
  resize: vertical !important;
}

.flex-wrap {
  flex-wrap: wrap;
}

@media only screen and (max-width: 992px) {
  .flex-wrap button {
    margin: 0px;
  }
}

.ql-align-center {
  text-align: center;
}

.ql-align-left {
  text-align: left;
}

.ql-align-right {
  text-align: right;
}

/* .ag-overlay-loading-wrapper {
  background: rgba(255, 255, 255, 0.922) !important;
} */
/* 
.ag-cell-normal-height {
  background: transparent !important;
} */

/* the below css is to hide the white row coming when searching in ag grid */
/* refer carunify bug id 54422 */
/* .ag-row-first.ag-row-last {
  background-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
} */

iframe {
  display: none !important;
}

#webpack-dev-server-client-overlay-div {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;EAC5C,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;;;;GAQG;;AAEH;;;;GAIG;;AAEH;;GAEG;;AAEH,qBAAqB;;AAErB;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,SAAO;EACP,2BAA2B;AAC7B;;;;AAIA,aAAa;;AAEb;EACE,kBAAkB;EAClB,UAAU;EACV,+CAA+C;AACjD;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;;;AAIA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,6BAAqB;UAArB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;AACH;;;GAGG;;AAEH,4EAA4E;AAC5E,gCAAgC;AAChC;;;;;GAKG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* .App {\n  text-align: center;\n} */\n/* :root {\n  --black: #000;\n  --white: #f5f5f5;\n}\n\nbody{\n  background: var(--background-color);\n  color: var(--text-color);\n}\n\nbody.light{\n  --background-color: var(--white);\n  --text-color:var(--black);\n}\nbody.dark{\n  --background-color: var(--black);\n  --text-color:var(--white);\n} */\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cookie-banner {\n  position: fixed;\n  bottom: 10px;\n  left: 10%;\n  right: 10%;\n  width: 80%;\n  color: #babfc7;\n  padding: 5px 9px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #050420;\n  border-radius: 5px;\n  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n  font-family: 'SFUIDisplayRegular';\n}\n\n.cookie-banner p {\n  margin-bottom: 0px;\n  font-family: 'SFUIDisplayRegular';\n  font-size: 13px;\n}\n\n.close {\n  height: 30px;\n  width: 130px;\n  font-size: 11px;\n  background-color: #32c167;\n  border: none;\n  color: #fff;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.react-confirm-alert-overlay {\n  background-color: #0e1726ba !important;\n}\n\n.react-confirm-alert-body > h1 {\n  color: #0e1726e0 !important;\n  font-family: 'SFUIDisplay-Medium' !important;\n  text-align: center !important;\n  font-size: 24px !important;\n}\n\n.react-confirm-alert-body {\n  background: #fff !important;\n  color: #0e1726e0 !important;\n  font-family: 'SFUIDisplayRegular' !important;\n  text-align: center !important;\n  font-size: 14px !important;\n  font-weight: bold;\n}\n\n.react-confirm-alert-button-group {\n  justify-content: center !important;\n}\n.react-confirm-alert-button-group > button {\n  background: #39979d !important;\n  color: #fff !important;\n  font-family: 'SFUIDisplay-Medium' !important;\n}\n\n.react-date-picker__wrapper {\n  border: none !important;\n}\n\n/*Ag grid Table*/\n\n.ag-theme-alpine .ag-root-wrapper {\n  border: none !important;\n  background: transparent !important;\n  text-overflow: initial !important;\n}\n\n.ag-theme-alpine .ag-header {\n  border-bottom: none !important;\n  margin-bottom: 5px;\n  border-radius: 10px !important;\n  min-height: 45px !important;\n  border: none !important;\n  text-overflow: ellipsis !important;\n  background: none !important;\n}\n\n.ag-header-cell-text {\n  text-overflow: ellipsis !important;\n}\n\n/* .ag-header-cell-label{\n  text-overflow: initial !important;\n  overflow: initial !important;\n}\n\n.ag-cell-value{\n  text-overflow: initial !important;\n  overflow: initial !important;\n} */\n\n/* @media only screen and (max-width: 400px) {\n  .ag-theme-alpine .ag-header-cell{\n    width: 91px !important;\n  }\n} */\n\n/* .ag-root.ag-layout-normal{\n  overflow: scroll;\n} */\n\n/*Ag grid Pagination*/\n\n.ag-theme-alpine .ag-paging-panel {\n  border-top: none !important;\n  color: #60677e !important;\n  font-size: 12px !important;\n  font-family: 'SFUIDisplayRegular' !important;\n}\n.ag-theme-alpine .ag-icon {\n  color: #60677e !important;\n}\n\n.ag-theme-alpine .ag-paging-panel > * {\n  margin: 0px -2px !important;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell {\n  display: flex !important;\n  align-items: center;\n  text-align: left;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell .ag-cell-wrapper,\n.ag-theme-alpine .ag-ltr .ag-cell .ag-cell-value {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  max-width: 100%;\n  flex: 1;\n  justify-content: flex-start;\n}\n\n\n\n/*date range*/\n\n.rdrCalendarWrapper {\n  position: absolute;\n  z-index: 1;\n  box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;\n}\n\n.rdrStartEdge,\n.rdrInRange,\n.rdrEndEdge {\n  color: #39979d !important;\n}\n\n.rdrDateDisplayItemActive {\n  border-color: #39979d !important;\n}\n\n.react-date-picker__inputGroup__input,\n.react-date-picker__inputGroup__divider {\n  color: #60677e !important;\n}\n\n.react-date-picker__button svg {\n  stroke: #60677e;\n}\n\n.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {\n  border: none !important;\n  border-color: none !important;\n  outline: none !important;\n}\n\n/* .ag-theme-alpine .ag-row-selected{\n  background: initial !important;\n} */\n\n/* .ag-theme-alpine .ag-row-hover{\n  background: #fff !important;\n} */\n\n.ag-center-cols-viewport {\n  height: calc(100% + 12px) !important;\n}\n\n.css-qc6sy-singleValue {\n  color: #60677e !important;\n}\n\n.popup-arrow {\n  display: none !important;\n}\n\ninput[type='checkbox' i] {\n  accent-color: #39979d !important;\n  vertical-align: middle;\n}\n\ninput:focus {\n  outline: none !important;\n}\n\ndiv[aria-expanded^='false'] .arrowdown {\n  display: initial !important;\n}\n\ndiv[aria-expanded^='false'] .arrowup {\n  display: none !important;\n}\n\ndiv[aria-expanded^='true'] .arrowup {\n  display: initial !important;\n}\n\ndiv[aria-expanded^='true'] .arrowdown {\n  display: none !important;\n}\n\n/* hide edge default eye icon */\ninput::-ms-reveal,\ninput::-ms-clear {\n  display: none !important;\n}\n.nav-item svg {\n  color: #747474;\n}\n.nav-item span {\n  color: #747474;\n}\n.DashMenu_menulinklightSelected__-6pNS a svg {\n  color: #020202 !important;\n}\n/* .list-unstyled .collapsed svg {\n  color: #747474 !important;\n}\n.list-unstyled .collapsed span {\n  color: #747474 !important;\n}\n.list-unstyled .btn-toggle a svg {\n  color: #020202;\n}\n.nav-item .list-unstyled .btn-toggle span {\n  color: #020202;\n}\n.nav-item .DashMenu_menulinklightSelected__-6pNS span {\n  color: #020202 !important;\n} */\n\n.has-active-sub-links {\n  color: #020202 !important;\n}\n.has-active-sub-links span {\n  color: #020202 !important;\n}\n.has-active-sub-links svg {\n  color: #020202 !important;\n}\n\n.delete {\n  background-color: rgb(214, 33, 33) !important;\n}\n.btn-toggle-nav li a {\n  column-gap: 0px !important;\n  padding: 0px 10px 0px 0px !important;\n}\n@media only screen and (max-width: 580px) {\n  body .buttons_resp {\n    display: block !important;\n  }\n  .buttons_resp button {\n    display: inline-block;\n    margin-right: 10px;\n  }\n}\n\n/* giving custom cursor pointer to ag grid rows */\n.ag-grid-custom-cp .ag-row {\n  cursor: pointer !important;\n}\n\n.ag-header-cell {\n  cursor: default !important;\n}\n\n.ag-header-cell-label {\n  cursor: pointer !important;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.ag-header-cell-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n\n\n.ag-row-selected {\n  background-color: white !important;\n}\n\nbody .exp_card {\n  max-width: 600px;\n  text-align: center;\n  margin: auto;\n  border: solid 1px #e8e8e8;\n  border-radius: 10px;\n}\n.exp_card h1 {\n  color: #041c3a;\n  font-weight: 700;\n  font-size: 38px;\n}\n.exp_card a {\n  text-decoration: auto;\n  color: #ffffff;\n  font-size: 18px;\n  background: #39979d;\n  padding: 7px 14px;\n  border-radius: 5px;\n  display: inline-block;\n}\n.exp_card a:hover {\n  color: #ffffff;\n  background: #114144;\n}\n\n.ql-editor {\n  min-height: 250px !important;\n  resize: vertical !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n@media only screen and (max-width: 992px) {\n  .flex-wrap button {\n    margin: 0px;\n  }\n}\n\n.ql-align-center {\n  text-align: center;\n}\n\n.ql-align-left {\n  text-align: left;\n}\n\n.ql-align-right {\n  text-align: right;\n}\n\n/* .ag-overlay-loading-wrapper {\n  background: rgba(255, 255, 255, 0.922) !important;\n} */\n/* \n.ag-cell-normal-height {\n  background: transparent !important;\n} */\n\n/* the below css is to hide the white row coming when searching in ag grid */\n/* refer carunify bug id 54422 */\n/* .ag-row-first.ag-row-last {\n  background-color: transparent !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n} */\n\niframe {\n  display: none !important;\n}\n\n#webpack-dev-server-client-overlay-div {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
